// hotelFlowOptions — pure quick-reply option constants for the hotel guided
// search flow.
//
// Extracted verbatim from `AIChatBot.js` (module-level `LOCATION_OPTIONS`,
// `BRAND_OPTIONS`, `BUDGET_OPTIONS`) as part of the behavior-preserving refactor
// (issue #240). These are static data used both by the pure flow-resolution
// helpers (resolveHotelFlowAction, resolveLocationStepAction) and by the
// stateful hooks that surface them as quick replies. Keeping them in one pure
// module avoids duplication and a circular dependency.
//
// React-free and side-effect-free. No behavior; data only.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * @typedef {Object} QuickReplyOption
 * @property {string} label
 * @property {string} value
 */

// ─── Hotel search flow constants ──────────────────────────────────────────────
/** @type {QuickReplyOption[]} */
export const LOCATION_OPTIONS = [
  { label: '📍 Near the airport', value: 'near the airport' },
  { label: '🏢 Near a business/office', value: 'near a business district' },
  { label: '🎡 Near an attraction', value: 'near popular attractions' },
  { label: '🏙️ Downtown / city center', value: 'downtown' },
];

/** @type {QuickReplyOption[]} */
export const BRAND_OPTIONS = [
  { label: '🔵 Marriott (Bonvoy)', value: 'Marriott' },
  { label: '🟡 Hilton (Honors)', value: 'Hilton' },
  { label: '🟢 Hyatt (World of Hyatt)', value: 'Hyatt' },
  { label: '🟠 IHG (One Rewards)', value: 'IHG' },
  { label: '🔴 Wyndham', value: 'Wyndham' },
  { label: '🌐 No preference', value: 'no preference' },
];

/** @type {QuickReplyOption[]} */
export const BUDGET_OPTIONS = [
  { label: '💰 Budget (<$120/night)', value: 'budget' },
  { label: '🏨 Mid-range ($120–$220)', value: 'mid-range' },
  { label: '✨ Luxury ($220+/night)', value: 'luxury' },
];

const hotelFlowOptions = { LOCATION_OPTIONS, BRAND_OPTIONS, BUDGET_OPTIONS };

export default hotelFlowOptions;
